<template>
  <section>
    <ul class="sidebar-nav lms-nav">
      <li class="nav-item">
        <router-link
          :to="{ name: 'lmsParticipant' }"
          class="nav-link"
          :class="{ active: $route.name == 'lmsParticipant' }"
          role="button"
        >
          <feather type="home"></feather>Нүүр
        </router-link>
      </li>
      <li class="nav-item" :class="{ show: courseNavExpanded() }">
        <router-link
          :to="{
            name: 'lmsCourses',
            params: { md: 1, cnm: 'null', type: -1, d1: 'null', d2: 'null' }
          }"
          class="nav-link with-sub"
          :class="{
            active: $route.name == 'lmsCourses' || $route.name == 'lmsAttend'
          }"
          role="button"
        >
          <feather type="award"></feather>Сургалтууд
        </router-link>
        <nav class="nav" v-if="courseNavExpanded()">
          <router-link
            :to="{
              name: 'lmsCourses',
              params: { md: 1, cnm: 'null', type: -1, d1: 'null', d2: 'null' }
            }"
            :class="{ active: this.$route.params.md == 1 }"
            role="button"
          >
            <span>Бүх нээлттэй сургалт</span>
            <span v-if="counts != undefined" class="badge">{{
              counts.allCount
            }}</span>
          </router-link>
          <router-link
            :to="{
              name: 'lmsCourses',
              params: { md: 2, cnm: 'null', type: -1, d1: 'null', d2: 'null' }
            }"
            :class="{ active: this.$route.params.md == 2 }"
            role="button"
          >
            Заавал хамрагдах сургалт
            <span v-if="counts != undefined" class="badge">{{
              counts.mustJoinCount
            }}</span>
          </router-link>
          <router-link
            :to="{
              name: 'lmsCourses',
              params: { md: 3, cnm: 'null', type: -1, d1: 'null', d2: 'null' }
            }"
            :class="{ active: this.$route.params.md == 3 }"
            role="button"
          >
            Миний үзэж буй сургалт
            <span v-if="counts != undefined" class="badge">{{
              counts.joinedCount
            }}</span>
          </router-link>
          <router-link
            :to="{
              name: 'lmsCourses',
              params: { md: 4, cnm: 'null', type: -1, d1: 'null', d2: 'null' }
            }"
            :class="{ active: this.$route.params.md == 4 }"
            role="button"
          >
            Миний дууссан сургалт
            <span v-if="counts != undefined" class="badge">{{
              counts.finishedCount
            }}</span>
          </router-link>
        </nav>
      </li>
      <!-- v-if="$store.state.app.activeGroup.id==9235" -->
      <li class="nav-item" v-if="$store.state.app.activeGroup.id == 9235 || $store.state.app.activeGroup.id == 9290">
        <router-link
          :to="{
            name: 'lmsNotif',
            params: { id: 0, cid: 0, title: 'Тушаал / Цахилгаан' }
          }"
          class="nav-link"
          :class="{ active: $route.name == 'lmsNotif' }"
        >
          <feather type="bell"></feather>Тушаал / Цахилгаан
        </router-link>
      </li>
      <li
        class="nav-item"
        v-if="
          $store.state.app.activeGroup.id != 9249 &&
            $store.state.user.userInfo.locType4Code == 'member'
        "
        :class="{
          show:
            $route.name == 'lmsMembership' ||
            $route.name == 'lmsMembershipEthic' ||
            $route.name == 'lmsMembershipOrg' ||
            $route.name == 'lmsMembershipPayment' ||
            $route.name == 'lmsParticipant' ||
            $route.name == 'lmsLegalList'
        }"
      >
        <router-link
          :to="{ name: 'lmsMembershipEthic' }"
          class="nav-link with-sub"
          :class="{
            active:
              $route.name == 'lmsMembership' ||
              $route.name == 'lmsMembershipEthic' ||
              $route.name == 'lmsMembershipOrg' ||
              $route.name == 'lmsMembershipPayment' ||
              $route.name == 'lmsLegalList'
          }"
        >
          <feather type="award"></feather>Гишүүнчлэлийн систем
        </router-link>
        <nav
          class="nav"
          v-if="
            $route.name == 'lmsMembership' ||
              $route.name == 'lmsMembershipEthic' ||
              $route.name == 'lmsMembershipOrg' ||
              $route.name == 'lmsMembershipPayment' ||
              $route.name == 'lmsParticipant' ||
              $route.name == 'lmsLegalList'
          "
        >
          <!-- <router-link
            to="/lms/membership"
            role="button"
            :class="{'active': $route.name=='lmsMembership' }"
          >
            <span>Эхлэл</span>
          </router-link>-->
          <router-link
            to="/lms/membershipEthic"
            role="button"
            :class="{ active: $route.name == 'lmsMembershipEthic' }"
          >
            <span>Ёс зүйн тайлан</span>
          </router-link>
          <router-link
            v-if="hasPermission('crmclient')"
            to="/lms/membershipOrg"
            role="button"
            :class="{ active: $route.name == 'lmsMembershipOrg' }"
          >
            <span>Гишүүн байгууллага</span>
          </router-link>
          <router-link
            to="/lms/membershipPayment"
            role="button"
            :class="{ active: $route.name == 'lmsMembershipPayment' }"
          >
            <span>Гишүүнчлэлийн төлбөр</span>
          </router-link>
          <router-link
            to="/lms/legalList/0"
            role="button"
            :class="{ active: $route.name == 'lmsLegalList' }"
          >
            <span>Дүрэм журам</span
            ><span v-show="$store.state.app.activeGroup.id == 6126"
              >, Тайлан</span
            >
          </router-link>
        </nav>
      </li>
      <li
        v-if="hasPayment && $store.state.app.activeGroup.id != 9249"
        class="nav-item"
        :class="{ show: $route.name == 'lmsPaymentList' }"
      >
        <router-link
          :to="{ name: 'lmsPaymentList', params: { status: 0 } }"
          class="nav-link with-sub"
          :class="{ active: $route.name == 'lmsPaymentList' }"
        >
          <feather type="credit-card"></feather>Төлбөрийн нэхэмжлэхүүд
        </router-link>
        <nav class="nav" v-if="$route.name == 'lmsPaymentList'">
          <router-link
            to="/lms/paymentList/0"
            role="button"
            :class="{ active: this.$route.params.status == 0, cur: 0 }"
          >
            <span>Төлөгдөөгүй</span>
          </router-link>
          <router-link
            v-if="hasEbarimt"
            to="/lms/paymentList/1"
            role="button"
            :class="{ active: this.$route.params.status == 1, cur: 0 }"
          >
            <span>И-Баримт</span>
          </router-link>
          <router-link
            to="/lms/paymentList/2"
            role="button"
            :class="{ active: this.$route.params.status == 2, cur: 0 }"
          >
            <span>Бүгд</span>
          </router-link>
        </nav>
      </li>
      <li class="nav-item" :class="{ show: $route.name == 'lmsLibrary' }">
        <router-link
          :to="{
            name: 'lmsLibrary',
            params: { id: 0, cid: 0, title: 'Номын сан', m: 0 }
          }"
          class="nav-link with-sub"
          :class="{ active: $route.name == 'lmsLibrary' }"
        >
          <feather type="book-open"></feather>Номын сан
        </router-link>
        <nav class="nav" v-if="$route.name == 'lmsLibrary'">
          <template v-if="!hasPermission('learnlibraryorder')">
            <router-link
              to="/lms/library/0/0/null/0"
              role="button"
              :class="{ active: this.$route.params.m == 0 }"
            >
              <span>Цахим номууд</span>
              <span v-if="obj.rdy" class="badge">{{
                obj.data.book.digitalCount
              }}</span>
            </router-link>
            <router-link
              to="/lms/library/0/0/null/1"
              role="button"
              :class="{ active: this.$route.params.m == 1 }"
            >
              <span>Номын сан / Захиалга</span>
              <span v-if="obj.rdy" class="badge">{{
                obj.data.book.libraryCount
              }}</span>
            </router-link>
            <router-link
              to="/lms/library/0/0/null/2"
              role="button"
              :class="{ active: this.$route.params.m == 2 }"
            >
              <span>Миний номууд</span>
              <span
                v-if="obj.rdy && obj.data.order.acceptedCount > 0"
                class="badge"
                >{{ obj.data.order.acceptedCount }}/{{
                  obj.data.order.returnedCount
                }}</span
              >
            </router-link>
            <router-link
              to="/lms/library/0/0/null/3"
              role="button"
              :class="{ active: this.$route.params.m == 3 }"
            >
              <span>Захиалгын түүх</span>
              <span v-if="obj.rdy && obj.data.order.allCount > 0" class="badge"
                >{{ obj.data.order.inProgressCount }}/{{
                  obj.data.order.allCount
                }}</span
              >
            </router-link>
          </template>
          <template v-else>
            <router-link
              to="/lms/library/0/0/null/4"
              role="button"
              :class="{ active: this.$route.params.m == 4 }"
            >
              <span>Номын сангийн хяналт</span>
            </router-link>
            <router-link to="/lms/libraryOrder/504/0/0" role="button">
              <span>Захиалгууд</span>
            </router-link>
            <router-link to="/lms/libraryAdmin/181/0/0" role="button">
              <span>Номууд</span>
            </router-link>
          </template>
        </nav>
      </li>
      <li
        class="nav-item"
        v-if="$store.state.app.activeGroup.id != 9249"
        :class="{ show: $route.name == 'lmsEventList' }"
      >
        <router-link
          :to="{ name: 'lmsEventList', params: { status: 0 } }"
          class="nav-link with-sub"
          :class="{ active: $route.name == 'lmsEventList' }"
        >
          <feather type="calendar"></feather>Үйл явдлууд
        </router-link>
        <nav class="nav" v-if="$route.name == 'lmsEventList'">
          <router-link
            to="/lms/eventList/0"
            role="button"
            :class="{ active: this.$route.params.status == 0 }"
          >
            <span>Нээлттэй</span>
          </router-link>
          <router-link
            to="/lms/eventList/1"
            role="button"
            :class="{ active: this.$route.params.status == 1 }"
          >
            <span>Оролцсон</span>
          </router-link>
        </nav>
      </li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'lmsCalendar' }"
          class="nav-link"
          :class="{ active: $route.name == 'lmsCalendar' }"
        >
          <feather type="calendar"></feather>Календар
        </router-link>
      </li>
      <li
        v-if="$store.state.app.activeGroup.id != 9249"
        class="nav-item"
        :class="{
          show:
            $route.name == 'lmsResearchList' ||
            $route.name == 'lmsMagazineList' ||
            $route.name == 'lmsNewsList'
        }"
      >
        <router-link
          :to="{ name: 'lmsResearchList' }"
          class="nav-link with-sub"
          :class="{
            active:
              $route.name == 'lmsResearchList' ||
              $route.name == 'lmsMagazineList' ||
              $route.name == 'lmsNewsList'
          }"
        >
          <feather type="book-open"></feather>Судалгаа, Сонин сэтгүүл, мэдээлэл
        </router-link>
        <nav
          class="nav"
          v-if="
            $route.name == 'lmsResearchList' ||
              $route.name == 'lmsMagazineList' ||
              $route.name == 'lmsNewsList'
          "
        >
          <router-link
            to="/lms/researchList/0"
            role="button"
            :class="{ active: $route.name == 'lmsResearchList' }"
          >
            <span>Судалгааны ажлууд</span>
          </router-link>
          <router-link
            to="/lms/magazineList/0"
            role="button"
            :class="{ active: $route.name == 'lmsMagazineList' }"
          >
            <span>Сонин сэтгүүл</span>
          </router-link>
          <router-link
            to="/lms/newsList/0"
            role="button"
            :class="{ active: $route.name == 'lmsNewsList' }"
          >
            <span>Мэдээ мэдээлэл</span>
          </router-link>
        </nav>
      </li>
      <li class="nav-item" v-if="auditrequestindex > 0">
        <router-link
          :to="{ name: 'lmsAuditLicenseRequest', params: { id: 0 } }"
          class="nav-link"
          :class="{ active: $route.name == 'lmsAuditLicenseRequest' }"
        >
          <feather type="file-plus"></feather>Аудиторын тусгай зөвшөөрлийн
          хүсэлт
        </router-link>
      </li>
      <li class="nav-item" v-if="hasFeedback > 0">
        <router-link
          :to="{ name: 'lmsFeedback', params: { cid: 0 } }"
          class="nav-link"
          :class="{ active: $route.name == 'lmsFeedback' }"
        >
          <feather type="send"></feather>Санал хүсэлт
        </router-link>
      </li>
      <li class="nav-item" v-if="$store.state.app.activeGroup.id == 6126 && $store.state.user.userInfo.locType4Code!='member'">
        <router-link
          :to="{ name: 'lmsConfirm', params: { title: 'Батламж' } }"
          class="nav-link"
          :class="{ active: $route.name == 'lmsConfirm' }"
        >
          <feather type="award"></feather>Батламж
        </router-link>
      </li>
    </ul>
    <slot />
  </section>
</template>

<script>
import { hasOneOf } from "@/libs/tools";

export default {
  props: {
    counts: {
      type: Object,
      default: () => {}
    },
    obj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hasPayment: false,
      hasEvent: false,
      hasEbarimt: false,
      auditrequestindex: 0,
      hasFeedback: false
    };
  },
  mounted() {
    let _pay = this.$store.state.app.groupSettings.filter(
      x => x.key == "lmsAttendHasPayment"
    );
    if (_pay.length > 0 && _pay[0].value != undefined && _pay[0].value == "1") {
      this.hasPayment = true;
    }

    let _ebarimt = this.$store.state.app.groupSettings.filter(
      x => x.key == "paymentEbarimt"
    );
    if (
      _ebarimt.length > 0 &&
      _ebarimt[0].value != undefined &&
      _ebarimt[0].value == "1"
    ) {
      this.hasEbarimt = true;
    }

    let _event = this.$store.state.app.groupSettings.filter(
      x => x.key == "learnEventHide"
    );
    if (
      _event.length > 0 &&
      _event[0].value != undefined &&
      _event[0].value == "0"
    ) {
      this.hasEvent = true;
    }

    let _feedback = this.$store.state.app.groupSettings.filter(
      x => x.key == "lmsFeedback"
    );
    if (
      _feedback.length > 0 &&
      _feedback[0].value != undefined &&
      _feedback[0].value == "1"
    ) {
      this.hasFeedback = true;
    }

    if (
      this.$store.state.user.userInfo.groupId == 9157 &&
      this.$store.state.user.userInfo.defaultTasks.organizationTaskId != null
    ) {
      this.auditrequestindex++;
    }
  },
  methods: {
    courseNavExpanded() {
      let rv = true;
      if (
        this.$store.state.app.activeGroup.id == 9241 ||
        this.$store.state.app.activeGroup.id == 9249
      ) {
        if (this.$route.name == "lmsCourses") {
          rv = true;
        } else {
          rv = false;
        }
      } else if (
        !(
          this.$route.name == "lmsParticipant" ||
          this.$route.name == "lmsCourses"
        )
      ) {
        rv = false;
      }
      return rv;
      //$route.name=='lmsCourses' && ($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249)
    },
    // navopen(name) {
    //     if(name=='lmsCourses'){
    //       this.$router.push({
    //         name: 'lmsCourses',
    //         params:{
    //           md: 1,
    //           cnm: 'null',
    //           type:-1,
    //           d1: 'null',
    //           d2: 'null',
    //         }
    //       });
    //     }
    //     else if(this.$route.name!=name){
    //         this.$emit("route-changed");
    //         this.$router.push({ name: name });
    //     }
    // },
    // subNavOpen(id){
    //     this.$emit("sub-nav-change", id);
    // },
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    }
  }
};
</script>

<style></style>
